import { useEffect } from "react";
import { ContainerV2, H1, P } from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { useBatchSpreadsheetImport } from "./useBatchSpreadsheetImport";
import { SpreadsheetDropzone } from "./Components/SpreadsheetDropzone";
import { PlanilhaValidationTable } from "./Components/PlanilhaValidationTable";
import { PaymentMethodSelector } from "./Components/PaymentMethodSelector";

export const BatchSpreadsheetImport = () => {
  const {
    stepIndicator,
    tipoServico,
    modalidade,
    local,
    servico,
    colunas,
    identificador,
    selectedFile,
    validationResult,
    formaPagamento,
    setFormaPagamento,
    todosAprovados,
    handleFileSelected,
    handleRemover,
    handleDownloadModelo,
    handleImportar,
  } = useBatchSpreadsheetImport();

  useEffect(() => {
    Tracking.pageView(`mapa:agendamento-lote/servicos/${tipoServico}:pageview`);
  }, [tipoServico]);

  return (
    <ContainerV2
      nextButton={{
        title: "Criar agendamentos",
        disabled: !todosAprovados,
        onClick: handleImportar,
      }}
    >
      {stepIndicator}

      <div className="pt-8">
        <H1 className="mb-4">Importe a planilha do lote</H1>
        <P className="mb-8">
          Uma linha por veículo, com o identificador (placa, renavam ou chassi)
          e os dados do cliente correspondente.
        </P>
      </div>

      {modalidade && (
        <div className="mb-8 flex flex-col divide-y divide-solid divide-[#e5e5ea] overflow-hidden rounded-3xl border border-solid border-[#e5e5ea] bg-white shadow-[0_8px_24px_0_rgba(0,0,0,0.078)] md:flex-row md:divide-x md:divide-y-0">
          <div className="flex-1 px-8 py-4">
            <p className="font-['Mulish'] text-[10px] text-[#666]">
              Modalidade
            </p>
            <p className="font-['Mulish'] text-base font-bold text-[#20332f]">
              {modalidade}
            </p>
          </div>
          <div className="flex-1 px-8 py-4">
            <p className="font-['Mulish'] text-[10px] text-[#666]">Local</p>
            <p className="font-['Mulish'] text-base font-bold text-[#20332f]">
              {local}
            </p>
          </div>
          <div className="flex-1 px-8 py-4">
            <p className="font-['Mulish'] text-[10px] text-[#666]">Serviço</p>
            <p className="font-['Mulish'] text-base font-bold text-[#20332f]">
              {servico}
            </p>
          </div>
        </div>
      )}

      {validationResult ? (
        <PlanilhaValidationTable
          fileName={selectedFile?.name ?? ""}
          resultados={validationResult}
          identificador={identificador}
          onRemover={handleRemover}
        />
      ) : (
        <SpreadsheetDropzone
          columns={colunas}
          onFileSelected={handleFileSelected}
          onDownloadModelo={handleDownloadModelo}
        />
      )}

      {todosAprovados && (
        <PaymentMethodSelector
          value={formaPagamento}
          onChange={setFormaPagamento}
        />
      )}
    </ContainerV2>
  );
};
